import { useMeetingsContext } from '../contexts/MeetingsContext'

/**
 * Custom hook to determine if a meeting event should be highlighted in the spotlight flow.
 *
 * Checks if the event key matches the current spotlight event key stored in MeetingsContext.
 *
 * @param eventKey - The key of the event to check for spotlight status
 * @returns True if the event should be highlighted, false otherwise
 */
export const useHasSpotlight = (eventKey: string) => {
  const ctx = useMeetingsContext()
  return !!eventKey && ctx?.spotlightEventKey === eventKey
}
